import api from "../config";
import URLS from "../../constants/urls";
export const _getStatesBySiteID = async (siteId, pageNumber, pageSize) => {
    const response = await api.get(`${URLS.STATE}/${siteId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
};
